import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { collection, doc, getDoc, getDocs, onSnapshot, orderBy, query, where } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import Menu from '../../panel/Menu';

function Paymodecheckouts() {

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
    });

    const printRef = useRef();

    const [loading, setloading] = useState(false);
    const [fromDate, setfromDate] = useState("");
    const [toDate, settoDate] = useState("");
    const [paymodetype, setpaymodetype] = useState("");
    const [propertyId, setPropertyId] = useState("");
    const [payHistoryData, setpayHistoryData] = useState([]);
    const [paymodes, setpaymodes] = useState([]);

    // ✅ Get propertyId from authroles
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            if (user) {
                const roleSnap = await getDoc(doc(db, "authroles", user.uid));
                if (roleSnap.exists()) {
                    const roleData = roleSnap.data();
                    setPropertyId(roleData.propertyId);
                }
            }
        });
        return () => unsubscribe();
    }, []);

    // ✅ Fetch payment modes using propertyId
    useEffect(() => {
        if (!propertyId) return;

        const q = query(
            collection(db, 'paymentmodes'),
            where("propertyId", "==", propertyId),
            orderBy('createdAt', 'asc')
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            setpaymodes(snapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            })));
        });

        return () => unsubscribe();
    }, [propertyId]);

    // ✅ Get Report
    const getReport = async () => {

        if (!fromDate || !toDate || !paymodetype) {
            Toast.fire({ icon: "error", title: "Please select all fields" });
            return;
        }

        setloading(true);
        setpayHistoryData([]);

        const startDate = moment(fromDate).format("YYYY-MM-DD");
        const endDate = moment(toDate).format("YYYY-MM-DD");

        try {

            // ✅ Filter payhistory using propertyId
            const q1 = query(
                collection(db, 'payhistory'),
                where('propertyId', '==', propertyId),
                where('paymode1', '==', paymodetype)
            );

            const q2 = query(
                collection(db, 'payhistory'),
                where('propertyId', '==', propertyId),
                where('paymode2', '==', paymodetype)
            );

            const [snap1, snap2] = await Promise.all([getDocs(q1), getDocs(q2)]);

            const payHistoryMatches = [];
            const bookingIdSet = new Set();

            [...snap1.docs, ...snap2.docs].forEach(docSnap => {
                const data = docSnap.data();
                payHistoryMatches.push({ id: docSnap.id, ...data });
                bookingIdSet.add(data.bookingid);
            });

            const bookingIds = [...bookingIdSet];

            if (bookingIds.length === 0) {
                Toast.fire({ icon: "info", title: "No matching payments found." });
                setloading(false);
                return;
            }

            // ✅ Fetch bookings using propertyId
            const chunkSize = 30;
            const bookingsMap = {};

            for (let i = 0; i < bookingIds.length; i += chunkSize) {

                const chunk = bookingIds.slice(i, i + chunkSize);

                const bq = query(
                    collection(db, 'reservations'),
                    where('propertyId', '==', propertyId),
                    where('__name__', 'in', chunk)
                );

                const bSnap = await getDocs(bq);

                bSnap.forEach(bdoc => {
                    const bdata = bdoc.data();
                    const cDate = bdata.checkindate;

                    if (cDate >= startDate && cDate <= endDate) {
                        bookingsMap[bdoc.id] = bdata;
                    }
                });
            }

            // ✅ Fetch paymode names
            const allPaymodeIds = new Set(
                payHistoryMatches.flatMap(p => [p.paymode1, p.paymode2])
            );

            const paymodeMap = {};

            await Promise.all([...allPaymodeIds].map(async (pmid) => {
                const ref = doc(db, 'paymentmodes', pmid);
                const snap = await getDoc(ref);
                if (snap.exists()) {
                    paymodeMap[pmid] = snap.data().paymode;
                }
            }));

            const seenBookings = new Set();
            const result = [];

            payHistoryMatches.forEach(item => {

                if (!bookingsMap[item.bookingid] || seenBookings.has(item.bookingid)) return;

                result.push({
                    ...item,
                    paymode1: paymodeMap[item.paymode1] || '',
                    paymode2: paymodeMap[item.paymode2] || '',
                    booking: bookingsMap[item.bookingid]
                });

                seenBookings.add(item.bookingid);
            });

            setpayHistoryData(result);

        } catch (error) {
            Toast.fire({ icon: "error", title: error.message });
        }

        setloading(false);
    };

    return (
        <div>
            <Menu />
            <div className="content-wrapper">
                <section className="content mt-2">
                    <div className="container-fluid">

                        <button className="btn btn-secondary">
                            || Paymode Wise Report ||
                        </button>

                        <br /><br />

                        {/* Filters */}
                        <div className="card card-primary card-outline">
                            <div className="card-body">
                                <div className="row">

                                    <div className="col-sm-3">
                                        <label>Pay Mode</label>
                                        <select
                                            className="form-control"
                                            value={paymodetype}
                                            onChange={(e) => setpaymodetype(e.target.value)}
                                        >
                                            <option value="">Select</option>
                                            {paymodes.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.data.paymode}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="col-sm-3">
                                        <label>From Date</label>
                                        <input
                                            type="date"
                                            value={fromDate}
                                            onChange={(e) => setfromDate(e.target.value)}
                                            className="form-control"
                                        />
                                    </div>

                                    <div className="col-sm-3">
                                        <label>To Date</label>
                                        <input
                                            type="date"
                                            value={toDate}
                                            onChange={(e) => settoDate(e.target.value)}
                                            className="form-control"
                                        />
                                    </div>

                                    <div className="col-sm-3">
                                        <br />
                                        <button
                                            className="btn btn-info"
                                            onClick={getReport}
                                        >
                                            Get Report
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>

                        {/* Table */}
                        <table className="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Customer</th>
                                    <th>Mobile</th>
                                    <th>Checkin</th>
                                    <th>Paymode1</th>
                                    <th>Amount1</th>
                                    <th>Paymode2</th>
                                    <th>Amount2</th>
                                    <th>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {payHistoryData.length === 0 ? (
                                    <tr>
                                        <td colSpan="9" className="text-center">
                                            No data found
                                        </td>
                                    </tr>
                                ) : (
                                    payHistoryData.map((item, index) => {

                                        const booking = item.booking || {};
                                        const customer = booking.customers || {};
                                        const amount1 = parseFloat(item.amount1 || 0);
                                        const amount2 = parseFloat(item.amount2 || 0);
                                        const total = amount1 + amount2;

                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{customer.custname || '-'}</td>
                                                <td>{customer.mobile || '-'}</td>
                                                <td>{booking.checkindate}</td>
                                                <td>{item.paymode1}</td>
                                                <td>{amount1.toFixed(2)}</td>
                                                <td>{item.paymode2}</td>
                                                <td>{amount2.toFixed(2)}</td>
                                                <td>{total.toFixed(2)}</td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </table>

                    </div>
                </section>
            </div>
        </div>
    );
}

export default Paymodecheckouts;